import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    Box,
    Typography,
    Container,
    CircularProgress,
    List,
    ListItem,
    ListItemText,
    Divider,
} from "@mui/material";

function BusinessIntelligenceService() {
    const [businessintelligence, setBusinessintelligence] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios
            .get("/files/services/business_intelligence.txt")
            .then((res) => {
                setBusinessintelligence(res.data);
                setLoading(false);
            })
            .catch((err) => {
                console.error("Error fetching BI content:", err);
                setLoading(false);
            });
    }, []);

    return (
        <Container maxWidth="lg" sx={{ py: 2 }}>
            {/* Title */}
            <Typography
                variant="h3"
                align="center"
                gutterBottom
                sx={{
                    fontWeight: "bold",
                    color: "#030366",
                    mt: 7,
                    fontSize: {
                        xs: "1.8rem",  // mobile (~h4)
                        sm: "2.2rem",  // tablet (~h3)
                        md: "2.8rem",  // laptop (~h3+)
                        lg: "3rem",    // desktop (~h2)
                    },
                }}
            >
                Business Intelligence Services
            </Typography>

            {loading ? (
                <Box display="flex" justifyContent="center" mt={4}>
                    <CircularProgress color="secondary" />
                </Box>
            ) : (
                <>
                    {/* Subtitle */}
                    <Typography
                        variant="h5"
                        sx={{ mb: 2, fontWeight: "600", color: "#030366", }}
                    >
                        Expert Business Intelligence Services for Assured Optimum Growth
                    </Typography>

                    {/* Intro paragraph */}
                    <Typography variant="body1" sx={{ mb: 3, textAlign: "justify" }}>
                        Business Intelligence has transformed from being able to integrate
                        data and create reports and dashboards. With the changing market
                        dynamics where we see multiple mergers and acquisitions, new tools,
                        open-source BI stabilizing, majority of the workforce on the move,
                        etc., it is important that organizations be innovative and adaptable.
                        Quality of data is vital as the risk is high for decisions based on
                        inaccurate or incomplete information. Well-structured and
                        comprehensive BI solutions mitigate these risks and provide a
                        competitive advantage in the marketplace.
                    </Typography>

                    {/* Key Services */}
                    <Typography
                        variant="h4"
                        sx={{ mt: 4, mb: 2, fontWeight: "700", color: "#030366" }}
                    >
                        Key Services
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                        VENSYX Data Solutions BI Consulting Services include:
                    </Typography>
                    <List>
                        {[
                            "BI Assessment Study",
                            "Rationalization Services",
                            "BI Competency Center",
                            "Architecture Services",
                            "Tool Evaluation Services",
                        ].map((service, idx) => (
                            <ListItem key={idx} sx={{ pl: 0 }}>
                                <ListItemText primary={service} />
                            </ListItem>
                        ))}
                    </List>

                    <Divider sx={{ my: 4 }} />

                    {/* Business Value */}
                    <Typography
                        variant="h4"
                        sx={{ mt: 2, mb: 2, fontWeight: "700", color: "#030366" }}
                    >
                        Business Value
                    </Typography>
                    <List>
                        {[
                            "Strategic BI Projects aligned to Business Strategy",
                            "Enable faster and fact-based decision making",
                            "Reusable frameworks and components",
                            "Optimize BI use for users' most pertinent needs",
                            "Align operations to Strategic and Tactical needs",
                            "Lower costs for BI tools and processes",
                        ].map((value, idx) => (
                            <ListItem key={idx} sx={{ pl: 0 }}>
                                <ListItemText primary={value} />
                            </ListItem>
                        ))}
                    </List>
                </>
            )}
        </Container>
    );
}

export default BusinessIntelligenceService;
